import {useQuery} from "@tanstack/react-query";
import {fetchAttendanceSettings} from "./attendanceApi";

export const ATTENDANCE_SETTINGS_KEY = ["attendance-settings"];

// Pointage module state of the selected account. `enabled` stays false while
// loading or on error, so the page/menu/badge field never flash in for
// accounts that don't use it. `fresh: true` (settings screen) always refetches
// on mount and waits for the API instead of showing the cached value.
const useAttendanceSettings = ({fresh = false} = {}) => {
    const {data, isLoading, isFetching, isError} = useQuery({
        queryKey: ATTENDANCE_SETTINGS_KEY,
        queryFn: fetchAttendanceSettings,
        staleTime: fresh ? 0 : 60 * 1000,
        refetchOnMount: fresh ? "always" : true,
    });
    return {
        enabled: !!data?.enabled,
        dayStart: data?.day_start || "05:00",
        isLoading: isLoading || (fresh && isFetching && !isError),
        isError,
        settings: data,
    };
};

export default useAttendanceSettings;
